export const getRestaurantQueryOperationName = () => `getRestaurantQuery`
export const getRestaurantQuery = () => `
  query ${getRestaurantQueryOperationName()}($restaurantId: ID!) {
    restaurantV2(guid: $restaurantId) {
      ...on Restaurant {
        guid
        shortUrl
        name: whiteLabelName
        logoUrls {
          xs
        }
        creditCardConfig {
          amexAccepted
        }
        location {
          address1
          address2
          city
          state
          zip
          phone
        }
      }
    }
  }
`

export const getPayForCheckMutation = () => `
  mutation payForCheck($input: PayForCheckInput!) {
    payForCheck(input: $input) {
      __typename
      ...on PayForCheckResponse {
        remainingChecks {
          guid
        }
      }
      ...on PayForCheckError {
        code
        message
      }
    }
  }
`

export const getPayForCheckDoCheckoutMutation = () => `
  mutation capmanGuestSpa_payForCheckCloseout(
    $payCloseoutByCheckInput: PayCloseoutByCheckInput!
  ) {
    pay {
      closeoutByCheck(input: $payCloseoutByCheckInput) {
        __typename
        ... on PayCloseoutByCheckSuccess {
          check {
            id
          }
          payments {
            id
          }
        }
        ... on PayCloseoutByCheckError {
          code
          message
        }
      }
    }
  }
`

export const getUpdatePaymentIntentMutation = () => `
  mutation capmanGuestSpa_updatePaymentIntent(
    $updatePaymentIntentInput: PayUpdatePaymentIntentByCheckInput!
  ) {
    pay {
      updatePaymentIntentByCheck(input: $updatePaymentIntentInput) {
        __typename
        ... on PayUpdatePaymentIntentByCheckError {
          code
          message
        }
        ... on PayUpdatePaymentIntentByCheckSuccess {
           intentAmount {
             amount
             currency
           }
        }
      }
    }
  }
`

export const getFetchBearerTokenQueryOperationName = () =>
  `capmanGuestSpa_GetBearerToken`
export const getFetchBearerTokenQuery = () => `
  query ${getFetchBearerTokenQueryOperationName()} {
    pay {
      bearerToken {
        __typename
        ...on PayBearerToken {
           token
        }
        ... on PayBearerTokenError {
          code
          message
        }
      }
    }
  }
`

export const getCreatePaymentMethodMutationOperationName = () =>
  `capmanGuestSpa_CreatePaymentIntent`
export const getCreatePaymentMethodMutation = () => `
  mutation ${getCreatePaymentMethodMutationOperationName()}(
    $createPaymentIntentInput: PayCreatePaymentIntentByCheckInput!
  ) {
    pay {
      createPaymentIntentByCheck(input: $createPaymentIntentInput) {
        __typename
        ... on PayPaymentIntent {
          id
          sessionSecret
          intentAmount {
            amount
            currency 
          }
        }
        ... on PayPaymentIntentError {
          message
          code
        }
      }
    }
  }
`
